const ModernTemplate = ({ candidateData }) => {
    if (!candidateData) return null

    const {
        name,
        email,
        phone,
        basic_details,
        employment,
        education,
        projects,
        certifications,
        it_skills,
        candidate_languages,
    } = candidateData

    return (
        <div className="resume-modern grid grid-cols-3 w-[210mm] min-h-[297mm] max-w-[210mm] mx-auto bg-white text-gray-800 font-sans box-border relative overflow-hidden">
            {/* Sidebar */}
            <div className="col-span-1 bg-teal-700 text-white p-5 overflow-y-auto">
                <div className="flex flex-col space-y-6">
                    {/* Profile Photo Placeholder */}

                    {/* Contact */}
                    <div className="w-full">
                        <h2 className="text-sm uppercase mb-3 text-teal-100 font-bold tracking-wider relative after:content-[''] after:absolute after:bottom-[-6px] after:left-0 after:w-8 after:h-0.5 after:bg-teal-300">
                            Contact
                        </h2>
                        <div className="flex flex-col space-y-2 text-xs">
                            <div className="flex items-center space-x-2">
                                <div className="w-3.5">
                                    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                        />
                                    </svg>
                                </div>
                                <span>{email}</span>
                            </div>
                            <div className="flex items-center space-x-2">
                                <div className="w-3.5">
                                    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                                        />
                                    </svg>
                                </div>
                                <span>{phone}</span>
                            </div>
                            <div className="flex items-start space-x-2">
                                <div className="w-3.5 mt-0.5">
                                    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                        />
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                        />
                                    </svg>
                                </div>
                                <div className="text-xs">
                                    {basic_details?.address}, {basic_details?.city?.name}
                                    <br />
                                    {basic_details?.state?.name}, {basic_details?.country?.name}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Skills */}
                    {it_skills && it_skills.length > 0 && (
                        <div className="w-full">
                            <h2 className="text-sm uppercase mb-3 text-teal-100 font-bold tracking-wider relative after:content-[''] after:absolute after:bottom-[-6px] after:left-0 after:w-8 after:h-0.5 after:bg-teal-300">
                                Skills
                            </h2>
                            <div className="flex flex-col space-y-3 mt-2">
                                {it_skills.map((skill, index) => (
                                    <div key={index} className="w-full">
                                        <div className="flex justify-between mb-1">
                                            <span className="text-xs">{skill.skill.title}</span>
                                            <span className="text-xs">
                                                {skill.experience_year}y {skill.experience_month}m
                                            </span>
                                        </div>
                                        <div className="w-full h-2 bg-teal-900 rounded-full">
                                            <div
                                                className="h-2 bg-teal-300 rounded-full"
                                                style={{
                                                    width: `${Math.min(100, (skill.experience_year * 12 + skill.experience_month) / 0.6)}%`,
                                                }}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Languages */}
                    {candidate_languages && candidate_languages.length > 0 && (
                        <div className="w-full">
                            <h2 className="text-sm uppercase mb-3 text-teal-100 font-bold tracking-wider relative after:content-[''] after:absolute after:bottom-[-6px] after:left-0 after:w-8 after:h-0.5 after:bg-teal-300">
                                Languages
                            </h2>
                            <div className="flex flex-col space-y-3 mt-2">
                                {candidate_languages.map((lang, index) => {
                                    const proficiency = getLanguageProficiency(lang)
                                    return (
                                        <div key={index} className="w-full">
                                            <div className="flex justify-between mb-1">
                                                <span className="text-xs">{lang.language}</span>
                                                <span className="text-xs">{proficiency}</span>
                                            </div>
                                            <div className="w-full h-2 bg-teal-900 rounded-full">
                                                <div
                                                    className="h-2 bg-teal-300 rounded-full"
                                                    style={{ width: getProficiencyPercentage(proficiency) }}
                                                />
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )}

                    {/* Certifications */}
                    {certifications && certifications.length > 0 && (
                        <div className="w-full">
                            <h2 className="text-sm uppercase mb-3 text-teal-100 font-bold tracking-wider relative after:content-[''] after:absolute after:bottom-[-6px] after:left-0 after:w-8 after:h-0.5 after:bg-teal-300">
                                Certifications
                            </h2>
                            <div className="space-y-2 mt-2">
                                {certifications.map((cert, index) => (
                                    <div key={index} className="text-xs">
                                        <p className="font-medium">{cert.certification_name}</p>
                                        {cert.certification_date && (
                                            <p className="text-xs text-teal-200">Issued: {cert.certification_date}</p>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Main Content */}
            <div className="col-span-2 p-6 overflow-y-auto">
                {/* Header */}
                <div className="mb-6">
                    <h1 className="text-lg text-teal-700 font-bold">{name}</h1>
                    <p className="text-base text-teal-600 text-center font-medium mt-1">
                        {employment?.[0]?.job_title?.title || "Professional"}
                    </p>
                </div>

                {/* Summary */}
                {basic_details?.profile_summery && (
                    <div className="mb-6">
                        <h2 className="text-base text-teal-700 mb-3 pb-2 border-b-2 border-teal-100 font-semibold">
                            Professional Profile
                        </h2>
                        <p className="leading-relaxed text-sm">{basic_details.profile_summery}</p>
                    </div>
                )}

                {/* Experience */}
                {employment && employment.length > 0 && (
                    <div className="mb-6">
                        <h2 className="text-base text-teal-700 mb-3 pb-2 border-b-2 border-teal-100 font-semibold">
                            Work Experience
                        </h2>
                        <div className="space-y-4">
                            {employment.map((job, index) => (
                                <div
                                    key={index}
                                    className="relative pl-5 before:content-[''] before:absolute before:left-0 before:top-0 before:bottom-0 before:w-0.5 before:bg-teal-100 before:z-10"
                                >
                                    <div className="absolute left-[-3px] top-0 w-2 h-2 rounded-full bg-teal-500 z-20" />

                                    <div className="flex justify-between mb-1 flex-wrap">
                                        <h3 className="text-sm font-bold text-teal-700">{job.job_title?.title}</h3>
                                        <span className="bg-teal-100 text-teal-800 px-2 py-0.5 rounded-full text-xs">
                                            {job.start_month}/{job.start_year} -{" "}
                                            {job.end_month ? `${job.end_month}/${job.end_year}` : "Present"}
                                        </span>
                                    </div>
                                    <p className="font-medium text-teal-600 mb-1 text-sm">{job.current_company}</p>
                                    <p className="text-xs leading-relaxed">{job.job_profile}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Education */}
                {education && education.length > 0 && (
                    <div className="mb-6">
                        <h2 className="text-base text-teal-700 mb-3 pb-2 border-b-2 border-teal-100 font-semibold">Education</h2>
                        <div className="space-y-4">
                            {education.map((edu, index) => (
                                <div
                                    key={index}
                                    className="relative pl-5 before:content-[''] before:absolute before:left-0 before:top-0 before:bottom-0 before:w-0.5 before:bg-teal-100 before:z-10"
                                >
                                    <div className="absolute left-[-3px] top-0 w-2 h-2 rounded-full bg-teal-500 z-20" />

                                    <div className="flex justify-between mb-1 flex-wrap">
                                        <h3 className="text-sm font-bold text-teal-700">{edu.education_course?.title}</h3>
                                        <span className="bg-teal-100 text-teal-800 px-2 py-0.5 rounded-full text-xs">
                                            {edu.course_duration_start_year} - {edu.course_duration_end_year}
                                        </span>
                                    </div>
                                    <p className="font-medium text-teal-600 mb-1 text-sm">{edu.insitute_university}</p>
                                    {edu.education_course_specialty && (
                                        <p className="text-xs">
                                            {edu.education_course_specialty.title} • {edu.marks}%
                                        </p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Projects */}
                {projects && projects.length > 0 && (
                    <div>
                        <h2 className="text-base text-teal-700 mb-3 pb-2 border-b-2 border-teal-100 font-semibold">Key Projects</h2>
                        <div className="space-y-4">
                            {projects.map((project, index) => (
                                <div
                                    key={index}
                                    className="relative pl-5 before:content-[''] before:absolute before:left-0 before:top-0 before:bottom-0 before:w-0.5 before:bg-teal-100 before:z-10"
                                >
                                    <div className="absolute left-[-3px] top-0 w-2 h-2 rounded-full bg-teal-500 z-20" />

                                    <div className="flex justify-between mb-1 flex-wrap">
                                        <h3 className="text-sm font-bold text-teal-700">{project.project_tag}</h3>
                                        <span
                                            className={`px-2 py-0.5 rounded-full text-xs ${project.project_status === "Ongoing"
                                                ? "bg-green-100 text-green-800"
                                                : "bg-teal-100 text-teal-800"
                                                }`}
                                        >
                                            {project.project_status}
                                        </span>
                                    </div>
                                    <p className="text-xs mb-1 leading-relaxed">{project.project_description}</p>
                                    <p className="text-xs text-gray-600">
                                        Role: {project.role} • Team Size: {project.team_size}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

// Helper function to format language proficiency
const getLanguageProficiency = (lang) => {
    let level = ""
    const abilities = []

    if (lang.can_read) abilities.push("read")
    if (lang.can_write) abilities.push("write")
    if (lang.can_speak) abilities.push("speak")

    if (abilities.length === 3) level = "Fluent"
    else if (abilities.length === 2) level = "Intermediate"
    else if (abilities.length === 1) level = "Basic"

    return level ? level : "Basic"
}

// Helper function to get percentage width for proficiency bar
const getProficiencyPercentage = (proficiency) => {
    switch (proficiency) {
        case "Fluent":
            return "100%"
        case "Intermediate":
            return "70%"
        case "Basic":
            return "40%"
        default:
            return "20%"
    }
}

export default ModernTemplate
